/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useMemo, useReducer } from 'react';
import { UserProviderType } from './@types';
import userReducer from './reducer';

const initialState: any = {
  user: {
    Step: 1,
    email: '',
    phone: '',
    Amount: '',
    Wallet: '',
    linkRef: '',
    nickname: '',
    entityId: '',
    birthday: '',
    image_url: '',
    updateState: true,
    balance: 0,
    pending_balance: '0',
    hasFinancialPassword: false,
    emailTransfer: '',
    champBetOnwership: {
      lastCheckedTime: new Date('01/01/2000'),
      ownership: false
    }
  }
};

export const UserContext = createContext(initialState);

const UserProvider: React.FC<UserProviderType> = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialState);
  const provider = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return (
    <UserContext.Provider value={provider}>{children}</UserContext.Provider>
  );
};

export default UserProvider;
